var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("请在 "+_vm._s(_vm.date)+" 前主动添加客服，提供孩子基本学习情况，以便合理安排试听老师")]),_c('li',[_vm._v("请确保孩子听完整节试听课，与老师互动")]),_c('li',[_vm._v("仅有 1 次试听机会，临时或中途取消将导致优学卡失效")])])}
var staticRenderFns = []

export { render, staticRenderFns }